import { AutoFocusCompleted } from "../../Model/Efi";
import { FetchStatus } from "../../Model/FetchStatus";
import {
  ESuiteMode,
  ImagingModuleTestingState,
  ModuleState,
  SuiteModuleTestingState,
  SuiteState,
} from "../../Model/ModuleState";
import {
  EModuleStateAction,
  ModuleStateAction,
} from "../actions/ModuleStateActions";
import { CaptureProfile } from "./../../Model/CaptureProfile";
import { RootState } from "./RootReducer";
import { EImagingModuleStatus } from "../../Model/ModuleState";
import { EModuleType } from "../../Model/EModuleType";
import { getModulesByType } from "./ModuleReducer";

type State = {
  status: FetchStatus;
  moduleStateById: { [index: string]: ModuleState };
  moduleStateByType: { [index: number]: ModuleState };
  efiPathsById: { [index: string]: string[] };
  locateDropPathsById: { [index: string]: string[] };
  locateDropWellName: string ;
  locateDropDropNumber: number ;
  autoFocusById: { [index: string]: AutoFocusCompleted };
  disabledArrow?: boolean;
  //moduleStates: ModuleState[];
};

const initialState: State = {
  moduleStateById: {},
  moduleStateByType: {},
  efiPathsById: {},
  locateDropPathsById: {},
  locateDropWellName: "",
  locateDropDropNumber: 0,
  autoFocusById: {},
  status: {
    completed: false,
    pending: false,
    error: null,
  },
  disabledArrow: false,
};

function processModuleStateById(moduleStates: ModuleState[]) {
  const byId: { [index: string]: ModuleState } = {};
  const byType: { [index: number]: ModuleState } = {};
  for (let moduleState of moduleStates) {
    byId[moduleState.identifier] = moduleState;
    if (!byType[moduleState.moduleType])
      byType[moduleState.moduleType] = moduleState;
  }
  return { byId, byType };
}

export function moduleStatesReducer(
  state = initialState,
  action: ModuleStateAction
): State {
  switch (action.type) {
    case EModuleStateAction.FETCH_MODULE_STATES_PENDING:
      return {
        efiPathsById: state.efiPathsById,
        locateDropPathsById: state.locateDropPathsById,
        locateDropWellName: state.locateDropWellName,
        locateDropDropNumber: state.locateDropDropNumber,
        autoFocusById: state.autoFocusById,
        moduleStateById: {},
        moduleStateByType: {},
        status: {
          completed: false,
          pending: true,
          error: null,
        },
        disabledArrow: state.disabledArrow
      };
    case EModuleStateAction.FETCH_MODULE_STATES_SUCCESS:
      if (action.moduleStates == null) {
        throw new Error("Module states is null");
      }
      const processed = processModuleStateById(action.moduleStates);
      return {
        efiPathsById: state.efiPathsById,
        locateDropPathsById: state.locateDropPathsById,
        locateDropWellName: state.locateDropWellName,
        locateDropDropNumber: state.locateDropDropNumber,
        autoFocusById: state.autoFocusById,
        moduleStateById: processed.byId,
        moduleStateByType: processed.byType,
        status: {
          completed: true,
          pending: false,
          error: null,
        },
        disabledArrow: state.disabledArrow
      };
    case EModuleStateAction.FETCH_MODULE_STATES_ERROR:
      return {
        efiPathsById: state.efiPathsById,
        locateDropPathsById: state.locateDropPathsById,
        locateDropWellName: state.locateDropWellName,
        locateDropDropNumber: state.locateDropDropNumber,
        autoFocusById: state.autoFocusById,
        moduleStateById: {},
        moduleStateByType: {},
        status: {
          completed: true,
          pending: false,
          error: action.error,
        },
        disabledArrow: state.disabledArrow
      };
    case EModuleStateAction.UPDATE_MODULE_STATES:
      if (action.updatedModuleStates == null) {
        throw new Error("Updated module states is null");
      }
      const processed2 = processModuleStateById(action.updatedModuleStates);
      return {
        efiPathsById: state.efiPathsById,
        locateDropPathsById: state.locateDropPathsById,
        locateDropWellName: state.locateDropWellName,
        locateDropDropNumber: state.locateDropDropNumber,
        autoFocusById: state.autoFocusById,
        moduleStateById: processed2.byId,
        moduleStateByType: processed2.byType,
        status: {
          completed: true,
          pending: false,
          error: null,
        },
        disabledArrow: state.disabledArrow
      };

    case EModuleStateAction.UPDATE_MODULE_STATE:
      if (action.updatedModuleState == null) {
        throw new Error("Updated module state is null");
      }
      return {
        efiPathsById: state.efiPathsById,
        locateDropPathsById: state.locateDropPathsById,
        locateDropWellName: state.locateDropWellName,
        locateDropDropNumber: state.locateDropDropNumber,
        autoFocusById: state.autoFocusById,
        moduleStateById: {
          ...state.moduleStateById,
          [action.updatedModuleState.identifier]: action.updatedModuleState,
        },
        moduleStateByType: {
          ...state.moduleStateByType,
          [action.updatedModuleState.moduleType]: action.updatedModuleState,
        },
        status: {
          completed: true,
          pending: false,
          error: null,
        },
        disabledArrow: state.disabledArrow
      };
    case EModuleStateAction.UPDATE_MODULE_EFI_STATE:
      if (action.updatedEfiState == null) {
        throw new Error("Updated efi state is null");
      }
      return {
        ...state,
        efiPathsById: {
          ...state.efiPathsById,
          [action.updatedEfiState.imagerIdentifier]:
            action.updatedEfiState.imagePaths,
        },
      };
    case EModuleStateAction.UPDATE_MODULE_LOCATE_DROP_STATE:
      if (action.updatedLocateDropState == null) {
        throw new Error("Updated locate drop state is null");
      }
      return {
        ...state,
        locateDropPathsById: {
          ...state.locateDropPathsById,
          [action.updatedLocateDropState.imagerIdentifier]:
            action.updatedLocateDropState.imagePaths,
        },
        locateDropWellName: action.updatedLocateDropState.wellName,
        locateDropDropNumber: action.updatedLocateDropState.dropNumber,
      
      };
    case EModuleStateAction.UPDATE_MODULE_AUTO_FOCUS_STATE:
      if (action.updatedAutoFocusState == null) {
        throw new Error("Updated autofocus state is null");
      }
      return {
        ...state,
        autoFocusById: {
          ...state.autoFocusById,
          [action.updatedAutoFocusState.imagerIdentifier]:
            action.updatedAutoFocusState,
        },
      };
      case EModuleStateAction.UPDATE_DISABLED_ARROW:
      return {
        ...state,
        disabledArrow: action.updateDisabledArrow,
      };
    default:
      return state;
  }
}

export const selectModuleStateByType = (state: RootState) => {
  return state.moduleStateStore.moduleStateByType;
};

export const selectDetailModuleStateByType = (
  state: RootState,
  moduleType: EModuleType
) => {
  return state.moduleStateStore.moduleStateByType[moduleType];
};

export const getImagerTestingState = (
  state: RootState,
  imagerIdentifier: string
): ImagingModuleTestingState => {
  const imagerState =
    state.moduleStateStore.moduleStateById[imagerIdentifier]?.imager;
  if (imagerState == null) {
    throw new Error("Suite state is null");
  }
  return imagerState.testing;
};

export const getSuiteMode = (state: RootState): ESuiteMode => {
  const suiteState = state.moduleStateStore.moduleStateById["Suite"]?.suite;
  if (suiteState == null) {
    throw new Error("Suite state is null");
  }
  return suiteState.suiteMode;
};

export const getSuiteTestingState = (
  state: RootState
): SuiteModuleTestingState => {
  const suiteState = state.moduleStateStore.moduleStateById["Suite"]?.suite;
  if (suiteState == null) {
    throw new Error("Suite state is null");
  }
  return suiteState.testing;
};

export const getSuiteState = (state: RootState): SuiteState => {
  const suiteState = state.moduleStateStore.moduleStateById["Suite"]?.suite;
  if (suiteState == null) {
    throw new Error("Suite state is null");
  }
  return suiteState;
};

export const getModuleState = (
  state: RootState,
  moduleIdentifier: string
): ModuleState => state.moduleStateStore.moduleStateById[moduleIdentifier];

export const getModuleStateById = (state: RootState) =>
  state.moduleStateStore.moduleStateById;

export const getChillerModuleStates = (state: RootState) => {
  const chillerModules = getModulesByType(state)[EModuleType.CHILLER] ?? [];
  const chillerStates = chillerModules.map((module) =>
    getModuleState(state, module.identifier)
  );
  return chillerStates;
};

export const getModuleStatesFetchStatus = (state: RootState): FetchStatus =>
  state.moduleStateStore.status;

export const getEfiPathsById = (
  state: RootState
): { [index: string]: string[] } => state.moduleStateStore.efiPathsById;

export const getLocateDropPathsById = (
  state: RootState
): { [index: string]: string[] } => state.moduleStateStore.locateDropPathsById;

export const getAutoFocusById = (
  state: RootState
): { [index: string]: AutoFocusCompleted } =>
  state.moduleStateStore.autoFocusById;

export const getImagerCaptureProfile = (
  state: RootState,
  imagerIdentifier: string
): CaptureProfile => {
  const imagerModule = state.moduleStateStore.moduleStateById[imagerIdentifier];
  if (imagerModule == null) {
    throw new Error(`"Module with id:${imagerIdentifier}" not found`);
  }
  if (imagerModule.imager == null) {
    throw new Error(
      `"Imager module state with id:${imagerIdentifier}" not found`
    );
  }

  return imagerModule.imager.captureProfile;
};

export const getPlateBarcodesOnImager = (state: RootState): string[] => {
  let plateBarcodes: string[] = [];
  for (let key in state.moduleStateStore.moduleStateById) {
    let moduleState = state.moduleStateStore.moduleStateById[key];
    const plate = moduleState.imager?.plate;
    if (plate != null) {
      plateBarcodes.push(plate.barcode);
    }
  }
  return plateBarcodes;
};

export const getImagingStatusById = (
  state: RootState
): { [index: string]: boolean } => {
  let imagingStatusById: { [index: string]: boolean } = {};
  for (let key in state.moduleStateStore.moduleStateById) {
    let moduleState = state.moduleStateStore.moduleStateById[key];
    const isImaging = moduleState.imager?.state;
    if (isImaging != null) {
      imagingStatusById[moduleState.identifier] =
        isImaging === EImagingModuleStatus.Imaging;
    }
  }
  return imagingStatusById;
};

export const getStorageAvailability = (state: RootState): number => {
  const chamberStates = Object.values(state.moduleStateStore.moduleStateById)
    .filter((module) => module.moduleType === EModuleType.CHAMBER)
    .map((item) => item.chamber);
  const storageAvailability = chamberStates
    .map((item) => item?.remainingCapacity)
    .reduce((prev, next) =>
      prev !== undefined && next !== undefined ? prev + next : 0
    );
  return storageAvailability ? storageAvailability : 0;
};

export const getStorageFullCapacity = (state: RootState): number => {
  const chamberStates = Object.values(state.moduleStateStore.moduleStateById)
    .filter((module) => module.moduleType === EModuleType.CHAMBER)
    .map((item) => item.chamber);
  const storageFullCapacity = chamberStates
    .map((item) => item?.fullCapacity)
    .reduce((prev, next) =>
      prev !== undefined && next !== undefined ? prev + next : 0
    );
  return storageFullCapacity ? storageFullCapacity : 0;
};
